<div class="map-image-panel-parent">
  <div class="map-image-panel-child">
      <div id="main-map-image" class="main-map-image">
          <emap-node-layer [nodeLayerEvent$]="nodeLayerLoadEvent$"></emap-node-layer>
      </div>
      <emap-drug-information-table></emap-drug-information-table>
      <emap-navigator></emap-navigator>
  </div>
</div>
